import { Building2, AlertCircle, ArrowRight, Phone } from "lucide-react";

export const InfoCittadini = () => {
  return (
    <section
      id="informazioni"
      data-testid="info-cittadini-section"
      className="relative py-20 sm:py-28 bg-[#FBF9F6] border-y border-[#E5E1D8]"
    >
      <div className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="inline-block text-xs sm:text-sm font-bold uppercase tracking-[0.22em] text-[#2E4F3B] mb-4">
            Servizi utili
          </span>
          <h2
            data-testid="info-title"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-black text-[#1A1A1A] leading-[1.05] tracking-tight"
          >
            Informazioni utili
            <span className="text-[#2E4F3B] italic font-light"> per i cittadini.</span>
          </h2>
          <p className="mt-5 text-base sm:text-lg text-[#5C5C5C] leading-relaxed">
            Strumenti e contatti utili per chi è stato coinvolto dall'incendio o
            vuole portare una segnalazione.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5 sm:gap-6">
          {/* Sportello Comune */}
          <article
            data-testid="info-card-sportello"
            className="group flex flex-col bg-white border-2 border-[#E5E1D8] hover:border-[#2E4F3B] rounded-2xl p-7 sm:p-8 transition-all hover:-translate-y-1 hover:shadow-[0_15px_40px_rgba(0,0,0,0.08)]"
          >
            <div className="w-14 h-14 rounded-2xl bg-[#2E4F3B] text-white flex items-center justify-center mb-5">
              <Building2 className="w-7 h-7" strokeWidth={1.7} />
            </div>
            <h3 className="font-display text-xl sm:text-2xl font-black text-[#1A1A1A] leading-tight">
              Sportello Informativo del Comune
            </h3>
            <p className="mt-3 text-base text-[#5C5C5C] leading-relaxed flex-1">
              Il Comune di San Giuliano Terme ha attivato uno{" "}
              <strong className="text-[#1A1A1A]">sportello dedicato</strong> ai
              cittadini interessati ad avere informazioni e supporto in merito
              alle problematiche conseguenti agli incendi.
            </p>
            <div className="mt-5 flex flex-wrap gap-3 text-sm">
              <span className="inline-flex items-center gap-2 bg-[#FBF9F6] border border-[#E5E1D8] rounded-full px-3 py-1.5 text-[#5C5C5C]">
                <Phone className="w-3.5 h-3.5" />
                Contatti operativi in aggiornamento
              </span>
            </div>
            <a
              href="https://www.comune.sangiulianoterme.pi.it/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="info-comune-link"
              className="mt-5 inline-flex items-center gap-2 self-start rounded-full bg-[#2E4F3B] hover:bg-[#1f3828] text-white font-semibold text-sm px-5 py-2.5 transition-colors"
            >
              Vai al Comune
              <ArrowRight className="w-4 h-4" />
            </a>
          </article>

          {/* Segnalazioni */}
          <article
            data-testid="info-card-segnalazioni"
            className="group flex flex-col bg-white border-2 border-[#C15C3D]/40 hover:border-[#C15C3D] rounded-2xl p-7 sm:p-8 transition-all hover:-translate-y-1 hover:shadow-[0_15px_40px_rgba(193,92,61,0.15)]"
          >
            <div className="w-14 h-14 rounded-2xl bg-[#C15C3D] text-white flex items-center justify-center mb-5">
              <AlertCircle className="w-7 h-7" strokeWidth={1.7} />
            </div>
            <h3 className="font-display text-xl sm:text-2xl font-black text-[#1A1A1A] leading-tight">
              Segnalazioni all'Associazione
            </h3>
            <p className="mt-3 text-base text-[#5C5C5C] leading-relaxed flex-1">
              Usa il nostro modulo per raccogliere{" "}
              <strong className="text-[#1A1A1A]">criticità, richieste di
              aiuto e proposte</strong>. Ogni segnalazione viene letta e
              gestita dai volontari dell'associazione.
            </p>
            <a
              href="/segnalazioni"
              data-testid="info-segnalazioni-link"
              className="mt-5 inline-flex items-center gap-2 self-start rounded-full bg-[#C15C3D] hover:bg-[#a64830] text-white font-semibold text-sm px-5 py-2.5 transition-colors"
            >
              Apri il modulo
              <ArrowRight className="w-4 h-4" />
            </a>
          </article>
        </div>
      </div>
    </section>
  );
};
